var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageSrc)?_c('span',{staticClass:"icon-indicator",class:[_vm.theme, _vm.type]},[_c('img',{staticClass:"icon",attrs:{"src":_vm.imageSrc}})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97b33d24","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/article-levels/IconIndicator.vue
// module id = 1731
// module chunks = 27